'use client';

import { c as _c } from "react/compiler-runtime";
import classnames from 'classnames';
import { type ImageProps } from 'next/image';
import DefaultAvatar from '../assets/default-avatar.png';
import { ImageWithFallback } from '../image-with-fallback/image-with-fallback';
import { AvatarSize } from './avatarSize';
import styles from './avatar.module.scss';
export type AvatarProps = Omit<ImageProps, 'src'> & {
  size?: AvatarSize;
  src: ImageProps['src'] | null;
};
export const Avatar = t0 => {
  const $ = _c(13);
  let className;
  let rest;
  let sizes;
  let t1;
  if ($[0] !== t0) {
    ({
      className,
      size: t1,
      sizes,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = rest;
    $[3] = sizes;
    $[4] = t1;
  } else {
    className = $[1];
    rest = $[2];
    sizes = $[3];
    t1 = $[4];
  }
  const size = t1 === undefined ? AvatarSize.Small : t1;
  const sizeValue = size === AvatarSize.Tiny ? 40 : 80;
  const t2 = styles[`avatar--size-${size}`];
  let t3;
  if ($[5] !== className || $[6] !== t2) {
    t3 = classnames(styles.avatar, t2, className);
    $[5] = className;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const t4 = sizes ? sizes : `${sizeValue * 3}px`;
  let t5;
  if ($[8] !== rest || $[9] !== sizeValue || $[10] !== t3 || $[11] !== t4) {
    t5 = <ImageWithFallback {...rest} className={t3} fallbackSrc={DefaultAvatar} height={sizeValue} quality={85} sizes={t4} width={sizeValue} />;
    $[8] = rest;
    $[9] = sizeValue;
    $[10] = t3;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return t5;
};